import * as React from "react";
import { VALUE_PARSER_OPTIONS } from "../constants/defaultParserConfig";

function CheckboxOption({ label, checked, disabled, onChange }) {
  return (
    <label className={`checkbox-row !gap-2 !px-1.5 !py-1 ${disabled ? "cursor-not-allowed opacity-60" : ""}`}>
      <input
        type="checkbox"
        className="checkbox-input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="text-xs">{label}</span>
    </label>
  );
}

export default function ParserSettings({ config, updateConfig, disabled }) {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-x-2 gap-y-0.5">
        <CheckboxOption
          label="Skip attributes"
          checked={config.skipAttributes}
          disabled={disabled}
          onChange={(checked) => updateConfig("skipAttributes", checked)}
        />
        <CheckboxOption
          label="Skip XML declaration"
          checked={config.skipDeclaration}
          disabled={disabled}
          onChange={(checked) => updateConfig("skipDeclaration", checked)}
        />
        <CheckboxOption
          label="Skip comments"
          checked={config.skipComment}
          disabled={disabled}
          onChange={(checked) => updateConfig("skipComment", checked)}
        />
        <CheckboxOption
          label="Strip namespace prefixes"
          checked={config.skipNsPrefix}
          disabled={disabled}
          onChange={(checked) => updateConfig("skipNsPrefix", checked)}
        />
        {VALUE_PARSER_OPTIONS.map((option) => (
          <CheckboxOption
            key={option.key}
            label={option.label}
            checked={config[option.key]}
            disabled={disabled}
            onChange={(checked) => updateConfig(option.key, checked)}
          />
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1">
          <label className="text-[11px] font-medium text-slate-600">Max nested tags</label>
          <input
            type="number"
            min={1}
            className="input-field !rounded-lg !px-2 !py-1.5 text-xs"
            placeholder="No limit"
            value={config.maxNestedTags ?? ""}
            disabled={disabled}
            onChange={(e) => {
              const parsed = parseInt(e.target.value, 10);
              updateConfig("maxNestedTags", Number.isFinite(parsed) ? parsed : null);
            }}
          />
        </div>

        {!config.skipAttributes && (
          <div className="space-y-1">
            <label className="text-[11px] font-medium text-slate-600">Attribute prefix</label>
            <input
              type="text"
              className="input-field !rounded-lg !px-2 !py-1.5 text-xs"
              value={config.attributePrefix}
              disabled={disabled}
              onChange={(e) => updateConfig("attributePrefix", e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
